export default __webpack_public_path__ + "static/media/LOGO_THUMBNAIL.c068c5b1.jpg";